<style lang="scss" scoped="">
@import "../../../../assets/scss/mixins";

$leftWidth: 0px;
.min-gutter {
  .el-form-item {
    margin-bottom: 20px;
  }
}

.content-part {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;

  .content-left {
    width: $leftWidth;
  }

  .content-right {
    > h3 {
      left: $leftWidth;
    }

    left: $leftWidth;
    padding: 65px 20px 0 20px;

    .show-content {
      padding: 0 20px;
      display: block;
    }
  }

  .min-gutter {
    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form-item__label {
      font-size: 12px
    }
  }
}

.el-form .el-select {
  display: block;
}

.el-form .el-cascader {
  display: block;
}
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-right min-gutter">
        <h3 class="clearfix">Excel导入往来单位</h3>
        <el-form id="form" ref="attachmentForm" class="form-part" label-width="160px"
                 style="margin-top: 40px">
          <el-form-item label="导入模板">
            <a href="../../../../static/excels/批量新增往来单位模板.xlsx">
              <el-button type="reset">
                下载Excel导入往来单位模板
              </el-button>
            </a>
          </el-form-item>
          <el-form-item label="上传文件">
            <oms-upload-relation :multiple="false"
                                 :fileList="fileList"
                                 :formData="{objectType:'businessOrgExcel'}"
                                 accept="xlsx"
                                 @change="changeFiles"
                                 @isProgress="onUploadProgress"
                                 :clearUploadFiles="clearUploadFiles"
                                 @refreshCodes="setIsUploading"></oms-upload-relation>
            <el-tag class="mt-10" v-show="uploading" type="warning">正在上传文件, 请勿关闭窗口</el-tag>
            <div class="waring-tag">
              <i class="el-icon-warning"></i> 请选择单个Excel文件上传，单个文件最大包含500个往来单位。
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="importExcel('form')" native-type="submit" :disabled="doing"
                       v-show="!uploading">{{ doing ? "解析文件中..." : "上传Excel" }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {http} from '@/resources';
import utils from '@/tools/utils';

export default {
  components: {},
  name: 'importForm',
  props: {
    showtext: Boolean
  },
  data: function () {
    return {
      fileList: [],
      attachmentIdList: [],
      uploadingFiles: [],
      index: 0,
      doing: false,
      title: '上传Excel'
    };
  },
  computed: {
    uploading() {
      if (!this.uploadingFiles) {
        return false;
      }
      return this.uploadingFiles.some(val => val.isUploading);
    }
  },
  watch: {},
  mounted: function () {
  },
  methods: {
    setIsUploading(file) {
      this.uploadingFiles.forEach(val => {
        if (file.uid === val.uid) {
          val.isUploading = false;
        }
      })
    },
    onUploadProgress(file) {
      let containFlag = this.uploadingFiles.some(value => value.uid === file.uid);
      if (!containFlag) {
        let newFile = Object.assign({}, file, {isUploading: true});
        this.uploadingFiles.push(newFile);
      }
    },
    changeFiles(files) {
      this.attachmentIdList = files.filter(f => f.attachmentId).map(m => m.attachmentId);
    },
    clearUploadFiles() {
      this.uploadingFiles = [];
    },
    resetForm() {
      this.doing = false;
      this.fileList = [];
      this.attachmentIdList = [];
      this.uploadingFiles = [];
    },
    importExcel: function () {
      if (!this.attachmentIdList || this.attachmentIdList.length === 0) {
        this.$notify.warning({
          duration: 1500,
          name: '警告',
          message: '请上传EXCEL文件'
        });
        return;
      }
      this.doing = true;
      http.post('dhs-business-org/import', this.attachmentIdList, {timeout: 120000}).then(res => {
        if (res.data && res.data.path) {
          // 如果有url返回,则下载错误信息的Excel
          this.$store.commit('initPrint', {
            isPrinting: true,
            moduleId: '/base/org/biz',
            text: '导入的Excel文件中存在错误内容,正在导出内容存在错误的单位信息'
          });
          utils.download(res.data.path, '错误单位表');
          this.$store.commit('initPrint', {
            isPrinting: false,
            moduleId: '/base/org/biz',
            text: '请将错误内容编辑正确后重新上传'
          });
          this.$notify.warning({
            duration: 3000,
            name: '警告',
            message: '请将错误内容编辑正确后重新上传'
          });
        } else {
          this.$notify.success({
            duration: 2000,
            name: '成功',
            message: '导入EXCEL批量新增往来单位成功'
          });
        }
        this.doing = false;
        // 清空附件列表
        this.resetForm();
        this.$emit('change');
        this.$emit('right-close');
      }).catch(error => {
        this.$notify.error({
          message: error.response && error.response.data && error.response.data.msg || '导入EXCEL批量新增往来单位失败'
        });
        this.doing = false;
      });
    }
  }
};
</script>
